import React, { createContext, useContext, useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../config/api';

const CollectionContext = createContext();

export const CollectionProvider = ({ children }) => {
  const [collections, setCollections] = useState([]);
  const [collectionsWithCounts, setCollectionsWithCounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCounts, setLoadingCounts] = useState(false);
  const [error, setError] = useState(null);

  // Sadece koleksiyon bilgilerini getir (hızlı)
  const fetchCollections = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/collections');
      setCollections(data);
      setError(null);
    } catch (error) {
      console.error('Koleksiyonlar yüklenirken hata:', error);
      setError('Koleksiyonlar yüklenemedi');
      toast.error('Koleksiyonlar yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  // Koleksiyon ürün sayılarını getir (ayrı çağrı)
  const fetchCollectionsWithCounts = async () => {
    try {
      setLoadingCounts(true);
      const { data } = await api.get('/collections/product-counts');
      setCollectionsWithCounts(data);
    } catch (error) {
      console.error('Koleksiyon ürün sayıları yüklenirken hata:', error);
      // Hata durumunda sadece koleksiyonları göster, ürün sayıları olmadan
      setCollectionsWithCounts(collections.map(c => ({ ...c, product_count: 0 })));
    } finally {
      setLoadingCounts(false);
    }
  };

  // Hem koleksiyonları hem ürün sayılarını getir
  const fetchAllCollections = async () => {
    try {
      setLoading(true);
      setLoadingCounts(true);
      
      // İki API'yi paralel olarak çağır
      const [collectionsResponse, countsResponse] = await Promise.allSettled([
        api.get('/collections'),
        api.get('/collections/product-counts')
      ]);

      // Koleksiyonları set et
      if (collectionsResponse.status === 'fulfilled') {
        setCollections(collectionsResponse.value.data);
      }

      // Ürün sayılarını set et
      if (countsResponse.status === 'fulfilled') {
        setCollectionsWithCounts(countsResponse.value.data);
      } else {
        // Ürün sayıları alınamazsa, koleksiyonları ürün sayısı 0 ile set et
        if (collectionsResponse.status === 'fulfilled') {
          setCollectionsWithCounts(collectionsResponse.value.data.map(c => ({ ...c, product_count: 0 })));
        }
      }

      setError(null);
    } catch (error) {
      console.error('Koleksiyonlar yüklenirken hata:', error);
      setError('Koleksiyonlar yüklenemedi');
      toast.error('Koleksiyonlar yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
      setLoadingCounts(false);
    }
  };

  return (
    <CollectionContext.Provider value={{
      collections,
      collectionsWithCounts,
      loading,
      loadingCounts,
      error,
      fetchCollections,
      fetchCollectionsWithCounts,
      fetchAllCollections
    }}>
      {children}
    </CollectionContext.Provider>
  );
};

export const useCollections = () => {
  const context = useContext(CollectionContext);
  if (!context) {
    throw new Error('useCollections hook must be used within a CollectionProvider');
  }
  return context;
}; 